import React, { useState } from "react";
import {
    Input,
    FormControl,
    FormLabel,
    Select,
    Button,
    Flex,
    Collapse,
    NumberInput,
    NumberInputField,
    InputGroup,
    InputLeftAddon,
    Text,
    Textarea
} from "@chakra-ui/react";
import { LuChevronUp, LuChevronDown, LuAlignLeft, LuAlignCenter, LuAlignRight, LuBold, LuItalic, LuUnderline } from "react-icons/lu";

// Font size options for the dropdown
const fontSizeOptions = [
    "12", "14", "16", "18", "20", "24", "28", "32", "36", "48"
];

const TextBlockEditor = ({ block, onChange }) => {
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);

    const handleColorChange = (e) => {
        onChange({ ...block, props: { ...block.props, color: e.target.value } });
    };

    const handleFontSizeChange = (value) => {
        onChange({ ...block, props: { ...block.props, fontSize: value } });
    };

    const handleAlignmentChange = (alignment) => {
        if (alignment === "center") {
            onChange({ ...block, props: { ...block.props, alignment, "marginLeft": "0" } });
        } else if (alignment === "right") {
            onChange({ ...block, props: { ...block.props, alignment, "marginRight": "10","marginLeft": "0" } });

        } else {
            onChange({ ...block, props: { ...block.props, alignment, "marginLeft": "10" } });
        }

    };

    const handleFormatChange = (format) => {
        const currentValue = block.props[format];
        onChange({ ...block, props: { ...block.props, [format]: !currentValue } });
    };

    const handleMarginChange = (margin, value) => {
        onChange({ ...block, props: { ...block.props, [margin]: value } });
    };

    return (
        <div>
            <Textarea
                mt={3}
                style={{ backgroundColor: "white" }}
                value={block.props.text}
                placeholder="Enter text"
                onChange={(e) => onChange({ ...block, props: { ...block.props, text: e.target.value } })}
            />

            <Flex mt={4} gap={2} flexWrap="wrap">
                <FormControl maxW="120px">
                    <FormLabel fontSize="xs" mb={1}>Color</FormLabel>
                    <Flex style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white" }}>
                        <Input
                            type="text"
                            value={block.props.color}
                            size="sm"
                            onChange={handleColorChange}
                            width="100px"
                            style={{ border: "none" }}
                        />
                        <Input
                            type="color"
                            value={block.props.color}
                            size="sm"
                            p={0}
                            height="32px"
                            width="32px"
                            ml={1}
                            style={{ border: "none" }}

                            onChange={handleColorChange}
                        // style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white" }}
                        />
                    </Flex>
                </FormControl>

                <FormControl maxW="125px">
                    <FormLabel fontSize="xs" mb={1}>Font Size</FormLabel>
                    <Select
                        size="sm"
                        value={block.props.fontSize}
                        onChange={(e) => handleFontSizeChange(e.target.value)}
                        style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white" }}
                    >
                        {fontSizeOptions.map(size => (
                            <option key={size} value={size}>{size}</option>
                        ))}
                    </Select>
                </FormControl>

                <FormControl maxW="150px">
                    <FormLabel fontSize="xs" mb={1}>Alignment</FormLabel>
                    <Flex style={{ border: "1px solid #CCCCCC", borderRadius: "5px" }}>
                        <Button
                            size="sm"
                            onClick={() => handleAlignmentChange('left')}
                            bg={block.props.alignment === 'left' ? 'blue.100' : 'white'}
                            borderRadius="md"
                            borderRightRadius="0"
                            flex="1"
                        >
                            <LuAlignLeft />
                        </Button>
                        <Button
                            size="sm"
                            onClick={() => handleAlignmentChange('center')}
                            bg={block.props.alignment === 'center' ? 'blue.100' : 'white'}
                            borderRadius="0"
                            flex="1"
                        >
                            <LuAlignCenter />
                        </Button>
                        <Button
                            size="sm"
                            onClick={() => handleAlignmentChange('right')}
                            bg={block.props.alignment === 'right' ? 'blue.100' : 'white'}
                            borderLeftRadius="0"
                            // borderRadius="md"
                            flex="1"
                        >
                            <LuAlignRight />
                        </Button>
                    </Flex>
                </FormControl>

                <FormControl maxW="150px">
                    <FormLabel fontSize="xs" mb={1}>Format</FormLabel>
                    <Flex style={{ border: "1px solid #CCCCCC", borderRadius: "5px" }}>
                        <Button
                            size="sm"
                            onClick={() => handleFormatChange('bold')}
                            bg={block.props.bold ? 'blue.100' : 'white'}
                            borderRadius="md"
                            borderRightRadius="0"
                            flex="1"
                            fontWeight="bold"
                        >
                            <LuBold />
                        </Button>
                        <Button
                            size="sm"
                            onClick={() => handleFormatChange('italic')}
                            bg={block.props.italic ? 'blue.100' : 'white'}
                            borderRadius="0"
                            flex="1"
                            fontStyle="italic"
                        >
                            <LuItalic />
                        </Button>
                        <Button
                            size="sm"
                            onClick={() => handleFormatChange('underline')}
                            bg={block.props.underline ? 'blue.100' : 'white'}
                            borderLeftRadius="0"
                            // borderRadius="md"
                            flex="1"
                            textDecoration="underline"
                        >
                            <LuUnderline />

                        </Button>
                    </Flex>
                </FormControl>
            </Flex>

            <Text
                mt={3}
                size="xs"
                color="blue.500"
                cursor={"pointer"}
                onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
                width="full"
                style={{ display: "flex", alignItems: "center" }}
            >
                {showAdvancedOptions ? <LuChevronUp /> : <LuChevronDown />}<span style={{ marginLeft: "3px" }}>{showAdvancedOptions ? "Hide" : "Show"} Advanced Options</span>
            </Text>

            <Collapse in={showAdvancedOptions} animateOpacity>
                <Flex mt={4} gap={2} wrap="wrap">
                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Margin Top</FormLabel>
                        <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                            <NumberInput
                                value={block.props.marginTop}
                                min={0}
                                max={100}
                                onChange={(value) => handleMarginChange('marginTop', value)}
                                style={{ border: "none !important" }}

                            >
                                <NumberInputField />
                                {/* <NumberInputStepper>
                                    <NumberIncrementStepper />
                                    <NumberDecrementStepper />
                                </NumberInputStepper> */}
                            </NumberInput>
                            <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                        </InputGroup>
                    </FormControl>

                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Margin Right</FormLabel>
                        <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>
                            <NumberInput
                                value={block.props.marginRight}
                                min={0}
                                style={{ border: "none !important" }}
                                max={100}
                                onChange={(value) => handleMarginChange('marginRight', value)}
                            >
                                <NumberInputField />
                                {/* <NumberInputStepper>
                                    <NumberIncrementStepper />
                                    <NumberDecrementStepper />
                                </NumberInputStepper> */}
                            </NumberInput>
                            <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                        </InputGroup>
                    </FormControl>

                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Margin Bottom</FormLabel>
                        <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>

                            <NumberInput
                                value={block.props.marginBottom}
                                min={0}
                                style={{ border: "none !important" }}

                                max={100}
                                onChange={(value) => handleMarginChange('marginBottom', value)}
                            >
                                <NumberInputField />
                                {/* <NumberInputStepper>
                                    <NumberIncrementStepper />
                                    <NumberDecrementStepper />
                                </NumberInputStepper> */}
                            </NumberInput>
                            <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />
                        </InputGroup>
                    </FormControl>

                    <FormControl maxW="120px">
                        <FormLabel fontSize="xs" mb={1}>Margin Left</FormLabel>
                        <InputGroup size="sm" style={{ border: "1px solid #CCCCCC", borderRadius: "5px", backgroundColor: "white", paddingRight: "5px" }}>

                            <NumberInput
                                value={block.props.marginLeft}
                                min={0}
                                max={100}
                                style={{ border: "none !important" }}

                                onChange={(value) => handleMarginChange('marginLeft', value)}
                            >
                                <NumberInputField />
                                {/* <NumberInputStepper>
                                    <NumberIncrementStepper />
                                    <NumberDecrementStepper />
                                </NumberInputStepper> */}
                            </NumberInput>
                            <InputLeftAddon children="px" style={{ border: "none", borderRadius: "5px", backgroundColor: "white" }} />

                        </InputGroup>
                    </FormControl>
                </Flex>
            </Collapse>
        </div>
    );
};

export default TextBlockEditor;